import React from "react";
import CustomAddPage from "components/custom-pages/CustomAddPage";
import { getAllData } from "apis/customApiHandler";
import { useQuery } from "react-query";

const Add = ({ data, handleClick }) => {
  const { data: allTyreSize } = useQuery(["size-master"], () =>
    getAllData("/size-master", {
      limit: 3000,
      page: 1,
      searchQuery: "",
    })
  );
  const { data: allCompany } = useQuery(["company-master"], () =>
    getAllData("/company-master", {
      limit: 3000,
      page: 1,
    })
  );
  const [initialValues, setInitialValues] = React.useState({
    materialNo: data?.materialNo || "",
    category: data?.category
      ? { label: data.category, value: data.category }
      : "",
    productName: data?.productName || "",
    originalNSD: data?.originalNSD || "",
    _id: data?._id,
    company:
      (data?.company?._id && {
        value: data?.company?._id,
        label: data?.company?.name,
      }) ||
      "",
    tyreSize:
      (data?.tyreSize?._id && {
        value: data?.tyreSize?._id,
        label: data?.tyreSize?.name,
      }) ||
      "",
  });

  const inputFields = [
    {
      name: "company",
      label: "Select Company",
      type: "select",
      required: true,
      options: allCompany?.data?.map((make) => ({
        value: make._id,
        label: make.name,
      })),
    },
    {
      name: "tyreSize",
      label: "Select Tyre Size",
      type: "select",
      required: true,
      options: allTyreSize?.data?.map((make) => ({
        value: make._id,
        label: make.name,
      })),
    },
    {
      name: "category",
      label: "Select Category",
      type: "select",
      required: false,
      options: [
        { label: "RADIAL", value: "RADIAL" },
        { label: "BIAS", value: "BIAS" },
      ],
    },
    {
      name: "materialNo",
      label: "Material Number",
      type: "text",
      required: true,
    },
    // {
    //   name: "brand",
    //   label: "Brand",
    //   type: "text",
    //   required: true,
    // },
    {
      name: "productName",
      label: "Material Description",
      type: "text",
      required: true,
    },
    {
      name: "originalNSD",
      label: "Original NSD",
      type: "number",
      required: true,
    },
  ];

  return (
    <CustomAddPage
      pageTitle={data ? "Update Product Master" : "Add Product Master"}
      url={"product-master"}
      action={!data ? "create" : "update"}
      updateId={data?._id}
      queryKey="product-master"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
